import React from "react";
import logo from "../../logo.png";
const Header = (props) => {
    return <div className="LogoContainer">
        <img className="Logo" src={logo} alt="SERVICE-REISEN Logo"/>
    </div>;
};

export default Header;
